import { v4 as uuidv4 } from 'uuid';
import { deepClone, isBlank } from "@/common/utils";

export const meter = {
  state: {
    meters: {
      /*
        uuid: {
          uuid:
          num:
          type:
          description:
          energy_source_uuid:
          energystar_meter_id:
          serial_no:
          multiplier:
          name:
          long:
          lat:
          site_uuid:
          access_level:
          created_at:
          updated_at:
          last_sync_at:
        }
      */
    },
    site_meters: {

    }
  },
  mutations: {
    insertMeter(state, new_meter) {
      state.meters[new_meter.uuid] = new_meter;
    },

    insertSiteMeter(state, args) {
      if (state.site_meters[args.site_uuid]) {
        state.site_meters[args.site_uuid].push(args.meter_uuid);
      } else {
        state.site_meters[args.site_uuid] = [ args.meter_uuid ];
      }
    },

    updateMeter(state, payload) {
      const meter_uuid = payload.uuid;
      if (state.meters[meter_uuid]) {
        state.meters[meter_uuid] = payload;
      }
    },

    removeMeter(state, meter_uuid) {
      const meter = state.meters[meter_uuid];
      if (meter) {
        const site_uuid = meter.site_uuid
        delete state.meters[meter_uuid];
        state.site_meters[site_uuid] = state.site_meters[site_uuid].filter(function(a_UUID) {
          return a_UUID !== meter_uuid;
        });

        if (isBlank(state.site_meters[site_uuid])) {
          delete state.site_meters[site_uuid]
        }        
      }
    },

    removeSiteMeters(state, site_uuid) {
      const meter_uuids = state.site_meters[site_uuid];
      meter_uuids.forEach(function(meter_uuid) {
        delete state.meters[meter_uuid];
      });
      delete state.site_meters[site_uuid];
    },

    removeAllMeters(state) {
      state.meters = {};
      state.site_meters = {};
    }
  },
  actions: {
    addMeter({ commit }, payload) {
      console.log("Inside metermondule.js, addMeter(), payload ==> ", payload);
      let new_meter = payload;

      if (!new_meter.uuid) {
        const newUUID = uuidv4();
        console.log("Inside metermondule.js, addMeter(), newUUID ==> ", newUUID);
        new_meter.uuid = newUUID;  
        new_meter.created_at = new Date().toISOString();
        new_meter.updated_at = new Date().toISOString();
      }
      
      commit("insertMeter", new_meter);
      commit("insertSiteMeter", { site_uuid: new_meter.site_uuid, meter_uuid: new_meter.uuid });
      return new_meter.uuid;
    },

    modifyMeter({ commit }, payload) {
      const meter = deepClone(payload);
      meter.updated_at = new Date().toISOString();
      commit("updateMeter", meter);
    },

    timestampMeterSync({ commit, getters }, meter_uuid) {
      const meter = getters.getMeterByUUID(meter_uuid);
      meter.sync_on = new Date().toISOString();
      commit("updateMeter", meter);
    },

    deleteMeter({ commit, dispatch }, meter_uuid) {
      dispatch('deleteNotesByOwner', meter_uuid);
      dispatch('deleteImagesByOwner', meter_uuid);
      dispatch("nullifyAssetMeters", meter_uuid);
      commit("removeMeter", meter_uuid);
    },

    deleteMetersBySite({ getters, dispatch }, site_uuid) {
      const meters = getters.getMetersBySiteUUID(site_uuid);
      meters.forEach(function(meter) {
        dispatch('deleteMeter', meter.uuid);
      })
    },

    clearAllMeters({ commit }) {
      commit("removeAllMeters");
    }
  },
  getters: {
    allMeters(state) {
      return state.meters
    },

    allSiteMeters(state) {
      return state.site_meters
    },

    meterEmpty(_, getters) {
      return (Object.keys(getters.allMeters).length == 0)
    },

    getMeterByUUID(state) {
      return function(uuid) {
        const meter = state.meters[uuid];
        return meter ? deepClone(meter) : null;
      }
    },

    getMetersBySiteUUID(state, getters) {
      return function(site_uuid) {
        const meter_uuids = state.site_meters[site_uuid];
        if (meter_uuids) {
          return meter_uuids.map(function(meter_uuid) {
            return getters.getMeterByUUID(meter_uuid);
          });
        } else {
          return []
        }
      }
    },

    //getMeterByName(state) {
    //  return function(giveName) {
    //    const meter = Object.values(state.meters).find(function(meter) {
    //      return (metername == giveName)
    //    });
    //    return meter ? deepClone(meter) : null;
    //  }
    //},

    nbMetersBySite() {
      return function(ownerUUID) {
        return this.getMetersBySiteUUID(ownerUUID).length
      }
    },

    searchMetersBy(state, getters) {
      return function(args) {
        let meters = (args.site_id) ? getters.getMetersBySiteUUID(args.site_id) : Object.values(state.meters);
        console.log("Inside meter.module.js searchMetersBy (1), meters ==> ", meters);
        if (args.location_id) {
          meters = meters.filter(function(meter) {
            return meter.location_uuid == args.location_id;
          })
        }
        if (args.energy_source_uuid) {
          meters = meters.filter(function(meter) {
            return meter.energy_source_uuid == args.energy_source_uuid;
          })          
        }
        console.log("Inside meter.module.js searchMetersBy (2), meters ==> ", meters);
        return meters;
      }
    }
  }
}